// extracted by mini-css-extract-plugin
export default {"wrapper":"gsRXN1y","title":"ZKf8ZXY","switchWrapper":"KmdD_9J","switch":"hXMkWHU","slider":"a0HAH3g","label":"eHBmgwO"};